
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { css } from 'aphrodite';

import styles from './styles.js';

import Translatable from '../../../../../../../components/Translatable';

class Increment extends Component {
    static propTypes = {
        emitValue: PropTypes.func.isRequired,
        filterGroupCollectionIndex: PropTypes.number.isRequired,
        filterGroupIndex: PropTypes.number.isRequired,
        filterIndex: PropTypes.number.isRequired,
        id: PropTypes.string.isRequired,
        incrementValue: PropTypes.number,
        isDisabled: PropTypes.bool.isRequired,
        label: PropTypes.string,
        legendText: PropTypes.string,
        maxValue: PropTypes.number,
        minValue: PropTypes.number,
        unit: PropTypes.string,
        value: PropTypes.number.isRequired
    }

    state = {
        value: this.props.value || 0,
        incrementValue: this.props.incrementValue || 1
    }

    componentDidMount() {
        const { emitValue, id } = this.props;
        this._element = document.getElementById(id);
        this._element.addEventListener('incrementChange', emitValue);
    }

    emitValueChange = () => {
        const event = new Event('incrementChange', { bubbles: true });
        this._element.dispatchEvent(event);
    }

    decrement = () => {
        const { emitValueChange } = this;
        this.setState(({ incrementValue, value }) =>
            ({ value: Number(value) - incrementValue }), emitValueChange);
    }

    increment = () => {
        const { emitValueChange } = this;
        this.setState(({ incrementValue, value }) =>
            ({ value: Number(value) + incrementValue }), emitValueChange);
    }

    render() {
        const { decrement, increment } = this;
        const { value } = this.state;
        const {
            filterIndex,
            filterGroupIndex,
            filterGroupCollectionIndex,
            id,
            isDisabled,
            label,
            legendText,
            maxValue,
            minValue,
            unit
        } = this.props;
        return (
            <div className={css(styles.baseContainer)}>
                <fieldset className={css(styles.fieldSet)}>
                    <legend className={css(styles.visuallyHidden)}>
                        <span>
                            {legendText}
                        </span>
                    </legend>
                    <div className={css(styles.containerFallback)}>
                        <div className={css(styles.beforeFallback)}>
                            <div className={css(styles.table)}>
                                <div>
                                    <div
                                        className={
                                            isDisabled ?
                                                css(styles.disabledLabelText) :
                                                css(styles.labelText)
                                        }
                                    >
                                        <span>
                                            {label}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={css(styles.afterFallback)}>
                            <div className={css(styles.table)}>
                                <div className={css(styles.middleAlignedCell, styles.left)}>
                                    <button
                                        type="button"
                                        disabled={(minValue ? value === minValue : value === 0) || isDisabled}
                                        className={css(styles.button)}
                                        aria-controls=""
                                        onClick={decrement}
                                    >
                                        <span
                                            className={
                                                isDisabled ?
                                                    css(styles.icon, styles.iconDisabled) :
                                                    value > 0 ?
                                                        css(styles.icon) :
                                                        css(styles.icon, styles.iconDisabled)
                                            }
                                        >
                                            <svg
                                                viewBox="0 0 24 24"
                                                role="img"
                                                aria-label="subtract"
                                                focusable="false"
                                                style={{
                                                    display: 'block',
                                                    fill: 'currentcolor',
                                                    height: '1em',
                                                    width: '1em'
                                                }}
                                            >
                                                <rect
                                                    width="12"
                                                    height="2"
                                                    x="6"
                                                    y="11"
                                                    rx="1"
                                                />
                                            </svg>
                                        </span>
                                    </button>
                                </div>
                                <div
                                    id=""
                                    role="region"
                                    aria-live="polite"
                                    aria-label=""
                                    className={css(styles.middleAlignedCell, styles.center)}
                                >
                                    <div
                                        className={
                                            isDisabled ?
                                                css(styles.disabledText) :
                                                css(styles.text)
                                        }
                                        id={id}
                                        data-filter-index={filterIndex}
                                        data-filter-group-index={filterGroupIndex}
                                        data-filter-group-collection-index={filterGroupCollectionIndex}
                                        data-input-type="increment"
                                        data-value={value}
                                    >
                                        <Translatable
                                            content={{
                                                transKey: unit,
                                                count: value,
                                                replacements: {
                                                    number: value
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className={css(styles.middleAlignedCell, styles.right)}>
                                    <button
                                        type="button"
                                        className={css(styles.button)}
                                        disabled={(maxValue ? value === maxValue : false) || isDisabled}
                                        aria-controls=""
                                        onClick={increment}
                                    >
                                        <span
                                            className={
                                                isDisabled ?
                                                    css(styles.icon, styles.iconDisabled) :
                                                    css(styles.icon)
                                            }
                                        >
                                            <svg
                                                viewBox="0 0 24 24"
                                                role="img"
                                                aria-label="add"
                                                focusable="false"
                                                style={{
                                                    display: 'block',
                                                    fill: 'currentcolor',
                                                    height: '1em',
                                                    width: '1em'
                                                }}
                                            >
                                                <rect
                                                    width="12"
                                                    height="2"
                                                    x="6"
                                                    y="11"
                                                    rx="1"
                                                />
                                                <rect
                                                    width="2"
                                                    height="12"
                                                    x="11"
                                                    y="6"
                                                    rx="1"
                                                />
                                            </svg>
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>
            </div>
        );
    }
}

export default Increment;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/Filter/filters/Increment/Increment.jsx